import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconOpt: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconOpt"><Path d="M3.75 4.75H6.22886C7.32152 4.75 8.32776 5.34407 8.8556 6.30077L15.1444 17.6992C15.6722 18.6559 16.6785 19.25 17.7711 19.25H20.25M15.75 4.75H20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconOpt;
